// import type { Player$InputOptions } from '../types/Options';

import { AUTO_MODE } from './playlist';

/* eslint camelcase: 0 */

const DEFAULT_OPTIONS = {
   // logger: null,
   loggerLevel: 2,

   timecode: 0,
   frameRate: 23.976,

   autoStart: false,
   startTime: null,
   endTime: null,

   useNativeControls: false,

   useOriginTimeForPreview: true,

   playlistmode: AUTO_MODE,
   plalistAutoGoNext: true,
   playlistitle: '',
   playlistforcepoint: 0,

   showExtensions: true,
   alwaysShowExtensions: false,
   extensionsVisibilityTimeout: 2000,

   showPlay: true,
   showProgress: true,
   showVolume: true,
   showFullScreen: true,
   showClosedCaptions: true,
   showTOC: true,
   showAnnotations: true,
   showQuality: true,
   showAudioTracks: false,
   showPoster: true,
   showError: false,
   showPlaceholder: true,
   showPlaybackRate: true,
   showForward: true,
   showBackward: true,
   showSettings: true,
   showDownload: true,
   showDownloadVideo: true,
   showDownloadCC: false,
   showBottomNext: false,
   showBottomPrev: false,
   showCaptionSearch: false,
   showCrawl: false,
   crawl: {},
   downloadVideoURL: null,

   showHelp: true,
   showTitle: true,
   showNext: false,
   showNextFrame: false,
   showPrevFrame: false,
   showCCLayout: true,
   showTheaterMode: false,
   useMux: false,
   showSubtitles: false,
   skipDelta: 10,
   keyboardListeners: {},
   globalKeyboardListeners: false,
   isHandlingKeyboardEvents: true,

   bufferingTimeout: 200,

   // qualityLevel: null,
   // startLevel: null,

   hls: {
      maxFragLookUpTolerance: 0.001,
      maxMaxBufferLength: 60 // 60 s = 1 min; default - 10 min
   },

   shaka: {},

   mux: {
      env_key: '', // required
      page_type: 'watchpage', // (see docs) 'watchpage', 'iframe', or leave empty
      viewer_user_id: '', // ex: '12345'
      experiment_name: '', // ex: 'player_test_A'
      sub_property_id: '', // ex: 'cus-1'

      // Player Metadata
      player_name: 'RavnurPlayer',
      player_version: '3.3.3',
      player_init_time: '', // ex: 1451606400000

      // Video Metadata (cleared with 'videochange' event)
      video_id: '', // ex: 'abcd123'
      video_title: '', // ex: 'My Great Video'
      video_series: '', // ex: 'Weekly Great Videos'
      video_producer: '', // ex: 'Bob the Producer'
      video_content_type: '', // 'short', 'movie', 'episode', 'clip', 'trailer', or 'event'
      video_language_code: '', // ex: 'en'
      video_variant_name: '', // ex: 'Spanish Hard Subs'
      video_variant_id: '', // ex: 'abcd1234'
      video_duration: '', // in milliseconds, ex: 120000
      video_stream_type: 'on-demand', // 'live' or 'on-demand'
      video_encoding_variant: '', // ex: 'Variant 1'
      video_cdn: '' // ex: 'Fastly', 'Akamai'
   },

   i18n: null,

   hlsjsURL    : 'https://cdn.jsdelivr.net/npm/hls.js@1.4.0/dist/hls.min.js',
   shakaURL    : 'https://cdn.jsdelivr.net/npm/shaka-player@4.9.11/dist/shaka-player.compiled.min.js',
   flashPath   : '/',
   muxURL      : 'https://src.litix.io/core/4/mux.js',

   disableAutoUrlRewrite: false,

   useHTMLPlayer: false,
   useHLSJSPlayer: false
};

export default DEFAULT_OPTIONS;
